// extracted by mini-css-extract-plugin
module.exports = {"legendRow":"legendRow___XfvM4","item":"item___wpOJd","num":"num___12dC6","head":"head___2tDXO","dot":"dot___nV4hl","active":"active___10c8K"};